export default "__VITE_ASSET__8251c20f__"